import * as Yup from "yup";

export const referralSchema = Yup.object().shape({
  referringJob: Yup.string().required("Job reference is required"),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  jobTitle: Yup.string().required("Current job title is required"),
  employer: Yup.string(),
  resume: Yup.mixed().required("Resume is required"),
});
